import React from "react";
import "../spinner/spinner.scss";
import { CircularProgress } from "@mui/material";

function SpinnerLoading() {
  return (
    <div className="sparent">
       <CircularProgress />
    </div>
  );
}

export default SpinnerLoading;
